// extracted by mini-css-extract-plugin
module.exports = {"button":"button-1m_Ay","button_cancel":"button_cancel-8GTC4"};